export default {
  data() {
    return {
      userInfo: {}, //个人信息
    }
  },
  created() {
    this.getUserInfo()
  },
  methods: {
    //获取个人信息
    getUserInfo() {
      this.$axios.post('/api/users/getUserInfo').then((res) => {
        if (res.data.code === 0) {
          this.userInfo = res.data.data
        }
      })
    },
  },
}
